import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark, faClock } from "@fortawesome/free-solid-svg-icons";

const ReviewSubmittedModal = ({ onClose, novel }) => {
  return (
    <div className="w-full h-dvh bg-black/70 backdrop-blur-sm flex justify-center items-center fixed top-0 left-0 z-50">
      <div className="review-success-pop max-w-[520px] relative w-[90%] bg-gradient-mn rounded-lg md:rounded-[0.8vw] p-6 md:p-[2vw] flex flex-col gap-4 items-center text-center">
        <div
          className="absolute top-[-10px] right-[-10px] md:right-[-0.6vw] md:top-[-0.6vw] w-[20px] md:w-[1.2vw] h-[20px] md:h-[1.2vw] cursor-pointer flex items-center justify-center bg-red-500 border border-white rounded-full"
          onClick={onClose}
        >
          <FontAwesomeIcon
            icon={faXmark}
            className="text-white text-[12px] md:text-[0.8vw]"
          />
        </div>

        <div className="review-success-ring w-[70px] h-[70px] md:w-[4.5vw] md:h-[4.5vw] rounded-full bg-[#ffffff1f] flex items-center justify-center">
          <div className="w-[52px] h-[52px] md:w-[3.4vw] md:h-[3.4vw] rounded-full bg-[#2aa9a0] flex items-center justify-center">
            <FontAwesomeIcon
              icon={faCheck}
              className="review-success-tick text-white text-[24px] md:text-[1.6vw]"
            />
          </div>
        </div>

        <h3 className="text-white times-new-roman text-[24px] md:text-[1.9vw] font-bold leading-tight">
          Thank you for your review!
        </h3>

        <p className="text-[#E4DDE4] text-[14px] md:text-[1vw] leading-relaxed max-w-[420px]">
          Your review has been submitted successfully
          {novel?.title ? (
            <>
              {" "}for <span className="text-white font-bold">{novel.title}</span>
            </>
          ) : null}
          .
        </p>

        <div className="flex items-center gap-2 bg-[#ffffff1f] rounded-md md:rounded-[0.5vw] px-4 py-2.5 md:px-[1vw] md:py-[0.7vw]">
          <FontAwesomeIcon
            icon={faClock}
            className="text-[#2aa9a0] text-[14px] md:text-[1vw]"
          />
          <span className="text-white text-[13px] md:text-[0.9vw]">
            It will appear here within 24 hours, once approved.
          </span>
        </div>

        <button
          onClick={onClose}
          className="mt-1 rounded-md md:rounded-[0.5vw] bg-[#2aa9a0] hover:bg-[#22908a] transition-colors text-white text-[14px] md:text-[0.95vw] font-bold px-8 md:px-[2.5vw] py-2.5 md:py-[0.65vw]"
        >
          Done
        </button>
      </div>
    </div>
  );
};

export default ReviewSubmittedModal;
